export class DscStorageLib {
    /**
     * 本地缓存中设置值
     * @param key
     * @param data
     */
    static localSet(key, data) {
        localStorage.setItem(key, JSON.stringify(data));
    }
    /**
     * 从缓存中获取指定key的数据
     * @param key
     * @returns
     */
    static localGet(key) {
        let storageData = null;
        try {
            storageData = JSON.parse(localStorage.getItem(key) || '');
        }
        catch (e) { }
        return storageData;
    }
    /**
     * 从本地缓存中异步移除指定key
     * @param key
     */
    static localRemove(key) {
        localStorage.removeItem(key);
    }
    /**
     * 会话缓存中设置值
     * @param key
     * @param data
     */
    static sessionSet(key, data) {
        sessionStorage.setItem(key, JSON.stringify(data));
    }
    /**
     * 从会话缓存中获取指定key的数据
     * @param key
     * @returns
     */
    static sessionGet(key) {
        let storageData = null;
        try {
            storageData = JSON.parse(sessionStorage.getItem(key) || '');
        }
        catch (e) { }
        return storageData;
    }
    /**
     * 从会话缓存中异步移除指定 key
     * @param key
     */
    static sessionRemove(key) {
        sessionStorage.removeItem(key);
    }
}
